<template>
  <v-btn @click="onClick" v-on="$listeners" v-bind="resetProps" :class="{ 'btn-loading': !!isLoading }">
    <slot name="pre-icon" />
    <slot>{{ title }}</slot>
    <slot name="icon" />
    <div class="loading">
      <AppLoader :size="18" :width="2" color="white" />
    </div>
  </v-btn>
</template>

<script>
export default {
  name: "Button",

  props: {
    title: {
      required: false,
      default: "",
      type: String,
    },

    isLoading: {
      default: false,
      type: Boolean,
    },

    onClick: {
      default: () => {},
      type: Function,
    },
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },
};
</script>

<style lang="scss">
body {
  button.v-btn {
    border-radius: 0.2rem;
    box-shadow: none !important;
    padding: 0rem 1.5rem;
    .v-btn__content {
      position: initial;
    }
    .loading {
      display: none;
    }

    &.btn-loading {
      pointer-events: none;
      .loading {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.15);
        .normal-loader {
          min-height: unset !important;
        }
      }
    }

    .app-icon {
      padding-inline-end: 1rem;
    }

    &.v-size--small {
      font-size: 1.4rem !important;
      line-height: 1.4rem !important;
      font-weight: 500;
      height: 3.2rem !important;
    }

    &.v-size--x-small {
      //height: 3.2rem !important
    }

    &.v-size--large {
      font-weight: bold;
      font-size: 1.8rem;
    }

    &.v-size--default {
      font-weight: 700;
    }

    &.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
      color: var(--v-white-base) !important;
      background-color: var(--v-primary-base) !important;
      opacity: 0.5;
    }

    &.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      color: var(--v-white-base) !important;
      background-color: var(--v-primary-base) !important;
      opacity: 0.5;
    }

    &.v-btn--outlined {
      border: thin solid rgba(0, 0, 0, 0.32);
    }

    &:not(.v-btn--round).v-size--default {
      min-width: 7.1rem;
      height: 4rem;
    }
  }
}
</style>
